const options = {
  visible: "md:overflow-y-visible",
  hidden: "md:overflow-y-hidden",
  auto: "md:overflow-y-auto",
  clip: "md:overflow-y-clip",
};

export default function getOverflowYMd(value) {
  return options[value];
}
